import get from "lodash/get";
import uiStrings from "./ui-strings.json";

/**
 * Gets the string value from the ui-string JSON based on specific path.
 * @param id The full path of the value to extract: "field.subfield.value1".  If stringPath is available, it should be only the key of the value: "value1".
 * @param stringPath Main path of the value to be extracted without the key, for "field.subfield.value1" tha main path is "field.subfield" and id is "value1".  If not present, id will be used as full path.
 */
export function getString(id: string, stringPath?: string, obj?: { [key: string]: any }): string {
    let fullPath = stringPath ? stringPath + "." + id : id;
    let outputString = get(uiStrings, fullPath, "");
    if (obj != null) {
        for (const key in obj) {
            const formatKey = "{{" + key + "}}";
            outputString = outputString.replace(formatKey, obj[key]);
        }
    }
    return outputString;
};